var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.618,
    height: 3.393,
    viewBox: "0 0 22.618 3.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8f003c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "more_horiz_FILL0_wght400_GRAD0_opsz48",
    className: "cls-1",
    d: "M9.7,24.993a1.689,1.689,0,1,1,1.2-.495,1.636,1.636,0,0,1-1.2.495Zm9.613,0a1.689,1.689,0,1,1,1.2-.495A1.636,1.636,0,0,1,19.309,24.993Zm9.613,0a1.689,1.689,0,1,1,1.2-.495,1.636,1.636,0,0,1-1.2.495Z",
    transform: "translate(-8 -21.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.f4bafdbd88688d40ef4c817465fec764.svg";
export { ForwardRef as ReactComponent };